<style scoped lang="less" rel="stylesheet/less">
.coinWebView_box,
iframe {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 27;
  background: #0089ce;
  overflow: hidden;
}
.go_explain {
  position: absolute;
  font-size: 16px;
  color: #9CDEFF;
  background: url("../../../assets/img/class/icon.png") left center no-repeat;
  background-size: 16px;
  padding-left: 20px;
  z-index: 30;
  right: 30px;
  top: 30px;
}
html,
body {
  background: #007a9c;
  overflow: hidden;
}
.bottom_bg {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 29;
  pointer-events: none;
}
.bottom_bg img {
  width: 100%;
  height: auto;
}
.nonet {
  background: #007a9c;
  width: 100%;
  height: 100%;
  position: fixed;
  opacity: 0;
  top: 0;
  left: 0;

  text-align: center;
  display: flex;
  align-items: center;
  z-index: -1;
  .bg {
    pointer-events: none;
    width: 293px;
    height: 285px;
    margin: 0 auto;
    text-align: center;
    img {
      width: 100%;
    }
    .img {
      width: 280px;
      height: 280px;
      margin: 0 auto;
      background: url("../../../assets/img/common/no_network.png") center no-repeat;
      background-size: 100%;
    }
  }
  .nonet_tip {
    color: #005d77;
    font-size: 24px;
    margin-top: 25px;
    text-align: center;
    flex: 1;
  }
}
.show {
  opacity: 1;
  z-index: 30;
}
.errorTip {
  text-align: center;
  .tip {
    font-size: 16px;
    text-align: center;
    color: #fff;
    margin-top: 147px;
  }
  .reloadget {
    width: 160px;
    height: 48px;
    color: #fff;
    line-height: 48px;
    display: block;
    margin: 0 auto;
    text-align: center;
    margin-top: 20px;
    border-radius: 8px;
    background: #1eb3ff;
    cursor: pointer;
  }
  .reloadget:hover {
    color: #99D8F9;
    background: #12abf9;
  }
}
</style>
<template>
  <div class="coinWebView_box">
    <Back @goBack="closeCoinWebView" />
    <span class="go_explain cursor" @click="go_explain">金币说明</span>
    <iframe id="myframe" :src="iframeUrl" frameborder="0" v-if="isShowiframe"></iframe>
    <div class="bottom_bg">
      <img src="../../../assets/img/class/bottom_bg.png" alt />
    </div>
    <loading v-show="isLoading" />
    <div class="nonet" :class="[showNonet?'show':'']">
      <div class="bg">
        <div class="img"></div>
        <div class="nonet_tip">啊哦，网络飞到外太空了！</div>
      </div>
    </div>
    <div class="errorTip">
      <div class="tip">金币记录获取失败，请点击按钮重新加载！</div>
      <div class="reloadget" @click="reloading">点击重试</div>
    </div>
  </div>
</template>
<script>
import loading from "@/components/basic/loading.vue";
import Back from "@/components/basic/back.vue";
import { mapState, mapMutations, mapActions } from "vuex";
import utils from "utils";
import common from "common";
export default {
  name: "coinrecord",
  inject: ["pageReload"],
  data() {
    return {
      LIMI_ENV: LIMI_ENV === "electron",
      iframeUrl: "",
      isLoading: true, //是否显示Loading
      nonet: false,
      showNonet: false,
      isOnline: false,
      isOpenPage: false,
      isOpenPageNum: 0,
      pageOpen: {},
      errorTip: true,
      isShowiframe: true
    };
  },
  components: {
    loading,
    Back
  },
  computed: {
    ...mapState([
      "COOK"
    ])
  },
  props: {
    updateMark: {
      default: false,
      type: Boolean
    }
  },
  created() {
    let configurl = common.get("configurl") || {};
    let name = configurl.name || "online";
    this.iframeUrl = `${common.API["300208"]}coin?COOK=${ this.COOK}&device=h5&env=${name}`;
    // this.iframeUrl = `http://127.0.0.1:8000/coin?COOK=${this.COOK}&device=pc&env=${name}&entrance=speed`;
  },
  mounted() {
    let _self = this;
    window.addEventListener("online", () => {
      _self.isOnline = true;
      _self.showNonet = false;
      _self.pageReload();
    });
    window.addEventListener("offline", () => {
      _self.isOnline = false;
      _self.showNonet = false;
    });
    //监听iframe消息，并关闭页面
    window.addEventListener(
      "message",
      function(e) {
        if (e.data == "hideLoading") {
          _self.isOpenPage = true;
          _self.isLoading = false;
        }
      },
      false
    );

    //获取iframe元素
    let iFrame = document.getElementById("myframe");
    //iframe加载完毕后再发送消息，否则子页面接收不到message
    iFrame.onload = function() {
      iFrame.contentWindow.postMessage(common.getSession("COOK"), "*");
    };

    this.pageOpen = setInterval(this.pageOpenFn, 1000);
  },
  methods: {
    ...mapMutations(["refreshNet"]),
    go_explain(){
      if (!navigator.onLine) {
        this.refreshNet(false);
        return;
      }
      this.$router.push("/coinexplain")
    },
    pageOpenFn() {
      this.isOpenPageNum++;
      if (this.isOpenPageNum >= 10) {
        if (!this.isOpenPage) {
          this.errorTip = true;
          this.isLoading = false;
          this.isShowiframe = false;
        }
        clearInterval(this.pageOpen);
      }
    },
    //点击跳转到个人徽章页面
    closeCoinWebView() {
      this.$router.go(-1);
    },
    //点击跳转到个人徽章页面
    goMyBadge() {
      this.$router.push({ name: "myselfBadge" });
    },
    //刷新
    reloading() {
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventFailureButton",
        data: {
          page: "金币记录页"
        }
      });
      this.pageReload();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/bussiness/class/coinrecord.vue